import { useEffect, useState } from 'react'

const ID = 'PnUr7gavYi4'
const EV = 'vw:trailer'

// deschide trailerul de oriunde (butonul din Despre, linkul din meniu)
export const openTrailer = () => window.dispatchEvent(new Event(EV))

// Trailerul oficial într-o fereastră peste pagină; pornește doar când e deschisă
const Trailer = () => {
    const [open, setOpen] = useState(false)

    useEffect(() => {
        const on = () => setOpen(true)
        window.addEventListener(EV, on)
        return () => window.removeEventListener(EV, on)
    }, [])

    useEffect(() => {
        if (!open) return
        const key = (e) => { if (e.key === 'Escape') setOpen(false) }
        window.addEventListener('keydown', key)
        document.body.style.overflow = 'hidden'
        return () => { window.removeEventListener('keydown', key); document.body.style.overflow = '' }
    }, [open])

    if (!open) return null
    return (
        <div className="lightbox-backdrop trailer-modal" onClick={() => setOpen(false)} role="dialog" aria-modal="true" aria-label="Trailer oficial">
            <button type="button" className="lightbox-close" onClick={() => setOpen(false)} aria-label="Închide">✕</button>
            <div className="trailer-frame" onClick={(e) => e.stopPropagation()}>
                <iframe
                    src={`https://www.youtube-nocookie.com/embed/${ID}?autoplay=1&rel=0&modestbranding=1&playsinline=1`}
                    title="Vinewood Multiplayer, trailer oficial"
                    allow="autoplay; encrypted-media; picture-in-picture; web-share; fullscreen"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                />
            </div>
        </div>
    )
}

export default Trailer
